import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { pillars } from '../../data/whatYouGet';
export function WhatYouGet() {
  return <section className="bg-bg-secondary py-14 sm:py-16" data-id="element-264" data-mp="143gjy1emab8g">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-265" data-mp="100tqxx67mk9o">
        <SectionTag icon="🎁" data-id="element-266" data-mp="zzinxzkl9gjm">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-267" data-mp="1dza5ube87h2w">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-gris-texto sm:text-lg" data-id="element-268" data-mp="1nqwfw4etva42">
          Sesiones listas para que preparar el entrenamiento deje de comerse tu tiempo.
        </p>
        <p className="mt-2 text-sm font-semibold text-naranja" data-id="element-269" data-mp="1wr2rfkqyu00l">
          Sesiones listas · 6 Tomos · Planificación de 40 semanas · 100% Digital
        </p>
      </div>

      <div className="mx-auto mt-10 grid max-w-5xl gap-6 px-6 sm:px-8 lg:grid-cols-2" data-id="element-270" data-mp="1rtt2s7behsdt">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border-2 border-naranja bg-white p-6 shadow-leve sm:p-7" data-id="element-271" data-mp="2zxotza7r07lg" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-272" data-mp="3dwwrzzs6d9o2">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-azul-light" data-id="element-273" data-mp="3ivrf3dx6dkdz">
                <pillar.icon size={22} className="text-azul" data-id="element-274" data-mp="3nokedm9vk0io" />
              </div>
              <span className="rounded-full bg-verde-light px-3 py-1 text-xs font-semibold text-verde" data-id="element-275" data-mp="3smm1qjec2lzy">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-marino sm:text-xl" data-id="element-276" data-mp="5hd5rkpx8rii">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-277" data-mp="22j24ka4ftdqe">
              <span className="text-rojo line-through" data-id="element-278" data-mp="1xjpj9tt7sepx">Valor: {pillar.value}</span>
              <span className="font-semibold text-verde" data-id="element-279" data-mp="2bac9syotmyax">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-gris-texto" data-id="element-280" data-mp="26jvsv4lskujt">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-281" data-mp="26i1bu1dn5ml0">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-gris-texto" data-id="element-282" data-mp="2lal94le40zuj">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-verde" data-id="element-283" data-mp="2u9ge5u5f43w9" />
                  <span data-id="element-284" data-mp="2u740ht6p0fp0">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}